module.exports = __webpack_public_path__ + "img/shopee-payo.e3ec3b41.png";